<template>
	<v-card>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							
							<div style="width: 200px;" class="mr-1">
								<v-text-field clearable dense label="订单ID" outlined v-model="query.id">
								</v-text-field>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-text-field clearable dense label="学号" outlined v-model="query.studentNo">
								</v-text-field>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-text-field clearable dense label="学员姓名" outlined v-model="query.studentName">
								</v-text-field>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								    transition="scale-transition" offset-y
									min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.start" label="开始日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.start"  @input="menu1=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
									 transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.end" label="结束日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-select :items="statusItems" v-model="query.status" item-text="statusName" item-value="id"
									label="订单状态" dense outlined></v-select>
							</div>
							<v-btn @click="queryClicked" color="primary">查询</v-btn>
						</v-col>
					</v-row>
					<v-divider></v-divider>
				</template>
				<template v-slot:item.status="{item}">
					
					<span v-if="item.status =='1'">正常</span>
					<span v-if="item.status =='0'" style="color:red">已撤销</span>
				</template>
				<template v-slot:item.action="{item}">
					<v-btn @click="cancelOrder(item)"  color="deep-purple lighten-3" small style="color: #424242;"  :disabled="item.status =='0'">撤销</v-btn>
				</template>
				
			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="1" >
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					
					<v-col cols="10"   v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>
		
		<!-- 确定作废订单 -->
		<v-dialog title="确定撤销扣课时订单" v-model="cancel.dialog" max-width="600" persistent>
			<v-card class="">
				<v-card-title>
					<span>确定撤销划课订单吗？</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel.dialog = false">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<v-sheet class="pa-2 rounded">
						
						<v-row class="mt-3" dense>
							<v-col cols="6">
								<v-text-field label="订单时间" disabled v-model="cancel.order.createAt" dense
									outlined></v-text-field>
							</v-col>
							
							<v-col cols="6">
								<v-text-field label="姓名" disabled v-model="cancel.order.studentName" dense
									outlined></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field label="扣课时数" disabled v-model="cancel.order.reduceAmount" dense
									outlined></v-text-field>
							</v-col>
							
						</v-row>
					</v-sheet>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel.dialog=false">取消</v-btn>
					<v-btn @click="submitCancelOrder" :disabled="cancel.submitting" :loading="cancel.submitting" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
	import utils from "../../../config/utils"
	export default {
		name: "course-reduce-order-list",
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				
				data: {
					total: 0,
					headers: [
						{
							text: '订单ID',
							value: 'id',
							sortable: false
						},
						{
							text: '时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '姓名',
							value: 'studentName',
							sortable: false
						},
						{
							text: '扣除课时',
							value: 'reduceAmount',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '操作人',
							value: 'creatorName',
							sortable: false
						},
						{
							text: '备注',
							value: 'memo',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				statusItems: [{
						id: "",
						statusName: "全部"
					},
					{
						id: "1",
						statusName: "正常"
					},
					{
						id: "0",
						statusName: "已撤销"
					},
				],
				query: {
					loading: false,
					page: 1,
					size: 20,
					id:"",
					start: "",
					end: "",
					status:"",
					studentNo:"",
					studentName:""
				},
				cancel:{
					dialog:false,
					submitting:false,
					order:{}
				}
			}
		},
		created() {
			this.getTableDataList();
		},
		computed:{
			
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			
			getTableDataList() {
				const that = this;
				this.query.loading = true;

				const shopId = utils.getCurrentShopId();
				let url = `/financial/reduce/order/list/1/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				if (this.query.id) {
					url += "&id=" + this.query.id;
				}
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.studentNo) {
					url += "&studentNo=" + this.query.studentNo;
				}
				if (this.query.studentName) {
					url += "&studentName=" + this.query.studentName;
				}
				if (this.query.status) {
					url += "&status=" + this.query.status;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "已取消";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
		
			cancelOrder(item){
				this.cancel.order = item;
				this.cancel.dialog=true;
			},
			submitCancelOrder(){
				//提交作废
				this.cancel.submitting = true;
				// api
				const that = this;
				let url = `/financial/reduce/order/cancel/${this.cancel.order.id}`;

				this.axios.post(url, {}).catch(() => {
					that.cancel.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							that.cancel.dialog = false;
							that.cancel.submitting = false;
							return;
						} else {
							that.cancel.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.cancel.submitting = false;
						that.$noty.error('网络请求失败');
					}
				
				});
				
			}
		}
	}
</script>

<style>
</style>
